function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.036 5.048h11.872a.319.319 0 1 0 0-.637H2.036L6.067.461a.319.319 0 0 0-.446-.455L1.032 4.502l-.009.01.013-.013c-.02.02-.02.02-.024.027l-.006.007-.017.022-.012.023-.002.004-.015.028-.008.026-.002.008-.007.025c-.003.017-.003.017-.003.026l-.001.009-.002.026.001.02.002.014c0 .01 0 .01.003.027l.006.023.002.007c.003.012.003.012.01.028a.22.22 0 0 0 .011.025l.004.008.013.022.017.023.005.006.017.02.009.007-.011-.01L5.62 9.453a.318.318 0 0 0 .45-.005.319.319 0 0 0-.004-.45l-4.031-3.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.96 7.223H8.088a.318.318 0 1 0 0 .637H19.96l-4.032 3.95a.319.319 0 0 0 .446.455l4.589-4.496.008-.01-.01.01c.018-.018.018-.018.023-.025l.002-.002c.01-.01.01-.01.02-.025l.013-.024.002-.004-.088-.046.088.046.014-.028.008-.025.002-.005.008-.03.003-.026v-.004l.002-.03-.001-.023V7.51l-.004-.03-.007-.024-.001-.006-.001-.002-.009-.027-.011-.024-.005-.008c-.004-.01-.004-.01-.013-.024-.01-.015-.01-.015-.017-.022l-.003-.004-.019-.022-.007-.006.01.009-4.596-4.503a.318.318 0 1 0-.446.455l4.032 3.95z"
})));

var SvgTransferMenuIcon = function SvgTransferMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 22 13",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransferMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer_menu_icon.80b161c2.svg";
export { ForwardRef as ReactComponent };